export default __webpack_public_path__ + "static/logo_colour_mark-773fbcb6d54f35a6f12833a7b5be8afe.svg";